(function ($) {
    'use strict';

    /**
     * Инициализирует модуль
     */
    document.addEventListener('DOMContentLoaded', () => {
        let breadcrumbs = new MultilevelListBreadcrumbs();
    });

    function MultilevelListBreadcrumbs() {
        this.onMultilevelListIsLoaded();
        this.onGetData();
        this.onClear();

        this.onButtonLevelUpClick();
        this.onButtonShowListClick();
    }

    /**
     * Производит подписку на обработку события 'многоуровневый спискок загружен'
     *
     */
    MultilevelListBreadcrumbs.prototype.onMultilevelListIsLoaded = function () {
        var subscribeEventName = 'multilevel-list:loaded';

        $.subscribe(subscribeEventName, (e, listName, itemData) => {
            console.log('event-received: ' + subscribeEventName);

            this.setValue(listName, itemData);
        });
    };

    /**
     * Производит подписку на обработку события 'получить текущие данные из breadcrumbs'
     *
     */
    MultilevelListBreadcrumbs.prototype.onGetData = function () {
        var subscribeEventName = 'multilevel-list-breadcrumbs:get-data';

        $.subscribe(subscribeEventName, (e, listName, deferred) => {
            console.log('event-received: ' + subscribeEventName);

            let breadCrumbs = this.getBreadCrumbs(listName);
            if (!breadCrumbs) {
                deferred.reject();
                return;
            }

            deferred.resolve(breadCrumbs);
        });
    };

    /**
     * Производит подписку на обработку события 'очистить breadcrumbs'
     *
     */
    MultilevelListBreadcrumbs.prototype.onClear = function () {
        var subscribeEventName = 'multilevel-list-breadcrumbs:clear';

        $.subscribe(subscribeEventName, (e, listName) => {
            console.log('event-received: ' + subscribeEventName);

            this.clear(listName);
        });
    };

    /**
     * Обработчик события: клик по ссылке вверх на один уровень (назад)
     *
     */
    MultilevelListBreadcrumbs.prototype.onButtonLevelUpClick = function () {
        $(document).off('click', '.multilevel-list-breadcrumbs__btn-level-up');
        $(document).on('click', '.multilevel-list-breadcrumbs__btn-level-up', (e) => {
            e.preventDefault();

            let breadCrumbs = this.getBreadCrumbsByChild($(e.target));
            if (!breadCrumbs) {
                return;
            }

            $.publish('multilevel-list:load', [breadCrumbs.type, e.target.href]);
        });
    };

    /**
     * Обработчик события: клик по кнопке отобразить список
     *
     */
    MultilevelListBreadcrumbs.prototype.onButtonShowListClick = function () {
        $(document).off('click', '.multilevel-list-breadcrumbs__btn-show, .multilevel-list-breadcrumbs__title-link');
        $(document).on('click', '.multilevel-list-breadcrumbs__btn-show, .multilevel-list-breadcrumbs__title-link', (e) => {
            e.preventDefault();

            let breadCrumbs = this.getBreadCrumbsByChild($(e.target));
            if (!breadCrumbs) {
                return;
            }

            $.publish('multilevel-list:item-is-selected', [breadCrumbs]);
        });
    };

    /**
     * Устанавливает значение в BreadCrumbs для указанного многоуровневого списка
     *
     * @param {String} listType
     * @param {Object} data
     */
    MultilevelListBreadcrumbs.prototype.setValue = function (listType, data) {
        let breadCrumbs = this.getBreadCrumbs(listType);
        if (!breadCrumbs) {
            return;
        }

        if (!data) {
            this.clear(listType);
            return;
        }

        breadCrumbs.$element.attr('data-code', data.code);
        breadCrumbs.$element.attr('data-parent-code', data.parentCode);
        breadCrumbs.$element.attr('data-is-parent', data.isParent);

        breadCrumbs.$title.text($.trim(data.name));
        breadCrumbs.$value.val(data.code);

        breadCrumbs.$btnLevelUp.attr('data-code', data.parentCode);
        breadCrumbs.$btnLevelUp.attr('href', breadCrumbs.$btnLevelUp.attr('data-template-href') + data.parentCode);

        breadCrumbs.$titleLink.attr('href', breadCrumbs.$titleLink.attr('data-template-href') + data.code);

        breadCrumbs.$btnShow.attr('href', breadCrumbs.$btnShow.attr('data-template-href') + data.code);

        if (data.parentCode && (data.parentCode !== '-1')) {
            breadCrumbs.$element.addClass('d-flex');
        } else {
            breadCrumbs.$element.removeClass('d-flex');
        }

        $.publish('multilevel-list-breadcrumbs:changed');
    };

    /**
     * Производит очистку Breadcrumbs
     *
     * @param {String} listType
     *
     */
    MultilevelListBreadcrumbs.prototype.clear = function (listType) {
        this.setValue(listType, {
            code: '',
            name: '',
            parentCode: '',
            isParent: '1'
        });
    };

    /**
     * Возвращает объект содержащий ссылки на элементы отображающие текущую позицию в многоуровневом списке
     *
     * @param {String} filterType Тип фильтра
     *
     * @return {Object}
     */
    MultilevelListBreadcrumbs.prototype.getBreadCrumbs = function (filterType) {
        let $breadCrumbs = $(`.multilevel-list-breadcrumbs[data-type="${filterType}"]`);

        return this.getDataBreadCrumbs($breadCrumbs);
    };

    /**
     * Возвращает объект содержащий ссылки на элементы отображающие текущую позицию в многоуровневом списке
     *
     * @param {jQuery} $childElement
     *
     * @return {Object}
     */
    MultilevelListBreadcrumbs.prototype.getBreadCrumbsByChild = function ($childElement) {
        let $breadCrumbs = $childElement.closest('.multilevel-list-breadcrumbs');

        return this.getDataBreadCrumbs($breadCrumbs);
    };

    /**
     *
     *
     * @param {jQuery} $breadCrumbs
     *
     * @return {Object}
     */
    MultilevelListBreadcrumbs.prototype.getDataBreadCrumbs = function ($breadCrumbs) {
        if (!$breadCrumbs.length) {
            return null;
        }

        let type = $breadCrumbs.attr('data-type');
        let $btnLevelUp = $breadCrumbs.find('.multilevel-list-breadcrumbs__btn-level-up');
        let currentLink = $btnLevelUp.attr('data-template-href') + $breadCrumbs.attr('data-code');

        return {
            $element: $breadCrumbs,
            $value: $breadCrumbs.find('.multilevel-list-breadcrumbs__value'),
            $title: $breadCrumbs.find('.multilevel-list-breadcrumbs__title-link'),
            $titleLink: $breadCrumbs.find('.multilevel-list-breadcrumbs__title-link').first(),
            $btnLevelUp: $btnLevelUp,
            $btnShow: $breadCrumbs.find('.multilevel-list-breadcrumbs__btn-show'),
            link: currentLink,
            type: type,
            code: $breadCrumbs.attr('data-code'),
            name: $.trim($breadCrumbs.find('.multilevel-list-breadcrumbs__title').text()),
            parentCode: $breadCrumbs.attr('data-parent-code'),
            isParent: $breadCrumbs.attr('data-is-parent'),
            $multilevelList: $(`.multilevel-list[data-type="${type}"]`),
            multilevelListType: type
        };
    };

    /**
     * Возвращает данные указанные в DOM-элементе многоуровневого списка
     *
     * @param {jQuery} $item Ссылка на DOM-элемент
     *
     * @return {Object|Boolean}
     */
    MultilevelListBreadcrumbs.prototype.getData = function ($item) {
        if (!$item.length) {
            return false;
        }

        return {
            $multilevelList: this.getMultilevelListByChild($item),
            multilevelListType: this.getTypeByChild($item),
            $element: $item,
            code: $item.attr('data-code'),
            name: $.trim($item.find('.multilevel-list-breadcrumbs__title').text()),
            parentCode: $item.attr('data-parent-code'),
            isParent: $item.attr('data-is-parent')
        };
    };

})(window.jQuery);